import { Divider, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import UtilService from "../../../../../../helper/service";
//import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";



const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 5,
    '@media screen and (max-width: 600px)': {
      paddingTop: 5
    }
  },
  sectionTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683'
  },
  parentCardSection: {
    marginTop: 40,
    borderRadius: 20,
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    background: '#fff',
    padding: '20px 40px 40px 40px',
    '@media screen and (max-width: 600px)': {
      padding: '10px'
    }
  },
  pdfParentCardSection: {
    marginTop: 40,
    borderRadius: 20,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    background: '#fff',
    padding: '20px 40px 40px 40px'
  },
  cardSection: {
    marginTop: 20,
    borderRadius: 20,
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    background: '#fff'
  },
  foo: {},
  pdfCardSection: {
    marginTop: 20,
    borderRadius: 20,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  segmentCardSection: {
    marginTop: 20,
    borderRadius: 20,
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    background: '#fff',
    padding: '20px 30px'
  },
  pdfSegmentCardSection: {
    marginTop: 20,
    borderRadius: 20,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    padding: '20px 30px'
  },
  content: {
    padding: '0px 50px!important',
    '@media screen and (max-width: 600px)': {
      padding: '0px 10px!important'
    },
  },
  segmentContent: {
    padding: '0px 10px!important',
    '@media screen and (max-width: 600px)': {
      padding: '0px 10px!important'
    },
  },
  description: {
    fontSize: 16,
    fontFamily: 'roboto-medium',
    color: '#697683',
    marginTop: 40
  },
  bold: {
    fontFamily: 'roboto-black'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: 70
  },
  segmentRow: {
    minHeight: '100px',
    '@media screen and (max-width: 700px)': {
      minHeight: '80px'
    },
  },
  categoryTitle: {
    fontSize: 16,
    fontFamily: 'roboto-bold',
    color: '#697683',
    display: 'flex',
    alignItems: 'center',
    flex: 3,
    '@media (max-width: 768px)': {
      flex: 5,
    },
    '@media screen and (max-width: 600px)': {
      fontSize: 14
    }
  },
  segmentTagName: {
    fontFamily: 'roboto-bold',
    fontSize: 16,
    color: '#697683',
    flex: 1,
    paddingRight: 10,
    wordBreak: 'break-all',
    '@media screen and (max-width: 750px)': {
      fontSize: 12
    }
  },
  segmentBarDiv: {
    flex: 4
  },
  percentage: {
    fontSize: 32,
    fontFamily: 'Spartan-bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 2,
    '@media (max-width: 768px)': {
      flex: 5
    },
    '@media screen and (max-width: 600px)': {
      fontSize: 26
    }
  },
  participantCount: {
    fontSize: 32,
    fontFamily: 'Spartan-medium',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 2,
    '@media screen and (max-width: 600px)': {
      fontSize: 26
    }
  },
  participantIcon: {
    width: 20,
    height: 20,
    marginRight: 5,
    '@media screen and (max-width: 600px)': {
      width: 18,
      height: 18
    }
  },
  iconSection: {
    paddingTop: 5,
    flex: 5,
    display: 'flex',
    alignItems: 'center'
  },
  segmentBadge: {
    width: 20,
    height: 20
  },
  segmentValue: {
    color: '#FFFFFF',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    marginLeft: 5,
    marginTop: 3,
    '@media screen and (max-width: 750px)': {
      marginLeft: 3,
      fontSize: 16
    }
  },
  segmentBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    position: 'relative'
  },
  segmentValueDiv: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: 25,
    zIndex: 1,
    '@media screen and (max-width: 750px)': {
      left: 5
    }
  },
  segmentParticipants: {
    fontSize: 12,
    color: '#212D40',
    fontFamily: 'roboto-light',
    flex: 4
  }
}));

interface IProps {
  audienceImmersions: any[],
  audienceSafes: any[],
  safetyData: any;
  isMobile: boolean;
}

const AudienceOverall = (props: IProps) => {
  const classes = useStyles();
  const {
    audienceImmersions, audienceSafes, safetyData, isMobile
  } = props;
  const { sessionData, immersionIndex } = useSelector((state: any) => state.creatorExperienceManager);
  const { settings, cliped, immersion_overall } = useSelector((state: any) => state.analysis);
  const { pdfLoading } = settings;


  if (immersionIndex && immersion_overall) {
//
  }
  /*
  console.log(highestSegments);
  console.log(lowestSegments);
  console.log(participantsStatus);
  console.log(immersionIndex);
  console.log(immersion_overall);
*/

  const getParticipantsIconRow = (count: number, color: string, type: string) => {
    const fullRowCount = Math.floor(count / 14);
    const modCount = count % 14;
    return (
      fullRowCount > 0 ? (
        <div>
          {
            Array(fullRowCount).fill('').map((_, index) => (
              <div key={`${type}-${index}`}>
                {Array(14).fill('').map((_: any, index1) => (
                  <img
                    key={`${type}-${index}-${index1}`}
                    className={classes.participantIcon}
                    src={`/assets/icons/overview/participant-${color.toLowerCase()}-icon.svg`} alt='Participant'
                  />
                )
                )}
                <br />
              </div>
            ))
          }
          {
            Array(modCount).fill('').map((_, index) => (
              <img key={`${type}-${index}-mod`} className={classes.participantIcon} src={`/assets/icons/overview/participant-${color.toLowerCase()}-icon.svg`} alt='Participant' />
            ))
          }
        </div>
      ) : (
        <div>
          {
            Array(modCount).fill('').map((_, index) => (
              <img key={`${type}-${index}`} className={classes.participantIcon} src={`/assets/icons/overview/participant-${color.toLowerCase()}-icon.svg`} alt='Participant' />
            ))
          }
        </div>
      )
    )
  };

  const getPercentageDivColor = (color: string) => {
    switch (color.toLowerCase()) {
      case 'green':
        return 'rgba(29, 184, 89, 0.07)';
      case 'gray':
        return 'rgba(129, 146, 162, 0.07)';
      case 'red':
        return 'rgba(237, 86, 74, 0.07)';
      default:
        return 'rgba(29, 184, 89, 0.07)';
    }
  };

  const getColor = (color: string) => {
    switch (color.toLowerCase()) {
      case 'green':
        return '#1DB859';
      case 'gray':
        return '#8192A2';
      case 'red':
        return '#ED564A';
      default:
        return '#8192A2';
    }
  };

  const getPaddingTop = (value: any) => {
    return {
      paddingTop: value ? (isMobile ? 6 : 7) : 0
    }
  };

  const showSafety = useCallback(() => {
    const length = cliped ? Number(cliped.end_clip - cliped.start_clip) : Number(sessionData['session']['session_length']);
    const session_type = cliped ? cliped.session_type : sessionData['session']['session_type'];
    return UtilService.isShowSafety(session_type, length);
  }, [sessionData, cliped]);





  return (
    <div className={classes.root} id='audience'>
      {(audienceImmersions.length > 0 || audienceSafes.length > 0) && (
        <>
          
          <div className={pdfLoading ? classes.foo : classes.foo}>
            
            {audienceImmersions.length > 0 && (
              <div>
                
                <div className={pdfLoading ? classes.pdfCardSection : classes.cardSection}>
                  <div className={classes.content}>
                    {audienceImmersions.map((item, index) => (
                      <div key={index}>
                        <div className={classes.row}>
                          <div className={classes.categoryTitle}>{item['context_indicator']}</div>
                          <div className={classes.percentage} style={{ backgroundColor: getPercentageDivColor(item['color_indicator']), color: getColor(item['color_indicator']) }}>
                            <span style={getPaddingTop(item['category_percent'])}>{item['category_percent'] ? `${Math.round(item['category_percent'])}%` : '-'}</span>
                          </div>
                          <div className={classes.participantCount} style={{ color: getColor(item['color_indicator']) }}>
                            <span style={getPaddingTop(item['category_count'])}>{item['category_count'] ? item['category_count'] : '-'}</span>
                          </div>
                          <div className={classes.iconSection}>
                            {getParticipantsIconRow(item['category_count'], item['color_indicator'], item['context_indicator'])}
                          </div>
                        </div>
                        {index !== (audienceImmersions.length - 1) && <Divider />}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {(audienceSafes.length > 0 && safetyData && safetyData['safety_index'] > 1 && showSafety()) && (
              <div>
                <p className={classes.description}>How <span className={classes.bold}>Safe</span> were your participants during this experience?</p>
                <div className={pdfLoading ? classes.pdfCardSection : classes.cardSection}>
                  <div className={classes.content}>
                    {audienceSafes.map((item, index) => (
                      <div key={index}>
                        <div className={classes.row}>
                          <div className={classes.categoryTitle}>{item['context_indicator']}</div>
                          <div className={classes.percentage} style={{ backgroundColor: getPercentageDivColor(item['color_indicator']), color: getColor(item['color_indicator']) }}>
                            <span style={getPaddingTop(item['category_percent'])}>{item['category_percent'] ? `${Math.round(item['category_percent'])}%` : '-'}</span>
                          </div>
                          <div className={classes.participantCount} style={{ color: getColor(item['color_indicator']) }}>
                            <span style={getPaddingTop(item['category_count'])}>{item['category_count'] ? item['category_count'] : '-'}</span>
                          </div>
                          <div className={classes.iconSection}>
                            {getParticipantsIconRow(item['category_count'], item['color_indicator'], item['context_indicator'])}
                          </div>
                        </div>
                        {index !== (audienceSafes.length - 1) && <Divider />}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
      
    </div>
  )
};

export default AudienceOverall;